$(document).on('ready turbolinks:load', () => $('[data-name]').initial());
